    <div class="z-[150]  font-semibold absolute w-full h-full m-auto flex items-center justify-center">
    <span class="loader"></span>
</div>
